'use strict';

import { Helper } from './Helper.js';

export class Form {
	#allNavs;
	#allTabs;
	#backButton;
	#nextButton;
	#submitButton;
	#stickyBarSubmitButton;
	#helper;
	#stickybar;
	#tabIndex;

	constructor() {
		this.#allNavs = document.querySelectorAll( '.levcharity_tabs__nav li' );
		this.#allTabs = document.querySelectorAll(
			'.levcharity_tabs__content .levcharity_tabs__item'
		);
		this.#backButton = document.querySelector(
			'.levcharity_form__back_button'
		);
		this.#nextButton = document.querySelector(
			'.levcharity_form__next_button'
		);
		this.#submitButton = document.querySelector(
			'.levcharity_form__submit_button'
		);
		this.#helper = new Helper();

		this.#addAjaxLoaderStyles();

		this.admin_ajax = admin_ajax[ 0 ];

		this.#stickyBarSubmitButton = document.querySelector(
			'.donation_form_sticky_bar button[name="add-to-cart"]'
		);
		this.handleStickyBarSubmit();

		this.#stickybar = document.querySelector('.levcharity_form__donation_amount_wrapper .levcharity_form__donation_paying_currency');
		if(this.#stickybar){
			this.changeTotalAmountSymbol();
		}

	}


	changeTotalAmountSymbol(){
		const total_amount = document.querySelector('.donation_form_sticky_bar .total_sum .selected_amount');
		this.#stickybar.addEventListener('change', (event) => {
			if(total_amount){
				total_amount.innerText = event.target.dataset.currencysymbol + 0;
			}
		})


	}



	addCampaignToCart() {
		const addCampaignToCartForms = document.querySelectorAll(
			'form.add_campaign_to_cart,form.levcharity_user_approved_to_team'
		);
		const addCampaignToCartFormsButtons = document.querySelectorAll('.add-campaign-to-cart');
		const admin_ajax_url = admin_ajax[ 0 ];

		if ( addCampaignToCartForms && admin_ajax_url ) {
			addCampaignToCartForms.forEach( ( addCampaignToCartForm, key ) => {
				addCampaignToCartForm.addEventListener( 'submit', ( event ) => {
					event.preventDefault();
					document
						.querySelector( 'body' )
						.classList.add( 'ajax-loading' );
					const formdata = new FormData( event.target );
					const user_paying_currency = document.querySelector(
						'[name="user_paying_currency"]'
					);
					if ( user_paying_currency ) {
						formdata.append(
							'user_paying_currency',
							user_paying_currency.value
						);
					}
					fetch( admin_ajax_url, {
						method: 'POST',
						body: formdata,
					} )
						.then( ( response ) => response.json() )
						.then( ( data ) => {

							if (data.local_cart) {
								localStorage.setItem('cart', JSON.stringify(data.local_cart));
							}

							if ( data.redirect_url ) {
								window.location.href = data.redirect_url;
							} else {
								window.location.reload();
							}

							document
								.querySelector( 'body' )
								.classList.remove( 'ajax-loading' );
						} )
						.catch( ( error ) => {
							document
								.querySelector( 'body' )
								.classList.remove( 'ajax-loading' );
							console.error( 'Error:', error );
						} );
				} );
			} );
		}
		if (addCampaignToCartFormsButtons && addCampaignToCartForms) {
			addCampaignToCartFormsButtons.forEach((addCampaignToCartFormsButton, key) => {
				addCampaignToCartFormsButton.addEventListener('click', (event) => {
					event.preventDefault();
					let formButton = addCampaignToCartForms[0]?.querySelector('button[type="submit"]');
					if (formButton) {
						formButton.click();
					}
				});
			})
		}
	}

	#addAjaxLoaderStyles() {
		const createCampaignforms = document.querySelector(
			'.create-campaign--step-2 form'
		);
		const editCampaignform = document.querySelector(
			'.campaign-details > form'
		);
		const forms = [];
		if ( createCampaignforms ) {
			forms.push( createCampaignforms );
		}
		if ( editCampaignform ) {
			forms.push( editCampaignform );
		}
		if ( forms && forms.length > 0 ) {
			forms.forEach( ( form ) => {
				form.addEventListener( 'submit', function () {
					document
						.querySelector( 'body' )
						.classList.add( 'ajax-loader' );
				} );
			} );
		}
	}

	preventSubmitByEnter() {
		document.addEventListener( 'keydown', ( event ) => {
			if ( event.keyCode === 13 ) {
				event.preventDefault();
			}
		} );
	}

	cleanValidation = ( form ) => {
		if ( ! form ) {
			return;
		}

		document.addEventListener( 'click', (e) => {
			if (
				!e.target.closest('header') &&
				form.querySelector( '.levcharity_form__validation_wrapper' ) &&
				form
					.querySelector( '.levcharity_form__validation_wrapper' )
					.hasChildNodes()
			) {
				form.querySelector(
					'.levcharity_form__validation_wrapper'
				).innerHTML = '';
			}
		} );
	};

	printValidation = ( form, message ) => {
		const validationMessage = document.createElement( 'span' );
		validationMessage.style.color = 'red';
		validationMessage.innerHTML = message;
		document.body.classList.remove( 'ajax-loader' );
		const referenceDiv = form.querySelector( '.donation_variations' );
		let validationWrapper = form.querySelector(
			'.levcharity_form__validation_wrapper'
		);
		if ( ! validationWrapper ) {
			validationWrapper = document.createElement( 'div' );
			validationWrapper.className = 'levcharity_form__validation_wrapper';

			if ( referenceDiv ) {
				referenceDiv.parentNode.insertBefore(
					validationWrapper,
					referenceDiv
				);
			} else {
				form.appendChild( validationWrapper );
			}
		}
		validationWrapper.innerHTML = '';
		validationWrapper.appendChild( validationMessage );

		const rect = form.getBoundingClientRect();
		const formCenterY = rect.top + window.scrollY + rect.height / 2;
		const targetTop = formCenterY - window.innerHeight / 2;
		const maxScroll = Math.max(
			0,
			document.documentElement.scrollHeight - window.innerHeight
		);
		window.scrollTo( {
			top: Math.max( 0, Math.min( targetTop, maxScroll ) ),
			left: 0,
			behavior: 'smooth',
		} );

	};

	testSubmissionData( form ) {
		// eslint-disable-next-line no-undef
		const formData = new FormData( form );
		for ( const [ key, value ] of formData.entries() ) {
			console.log( key + ': ' + value );
		}
	}

	animatedScrollTo( targetElement, duration = 500 ) {
		const startingY = window.pageYOffset;
		const elementY =
			window.pageYOffset + targetElement.getBoundingClientRect().top;
		const targetY =
			( document.body.scrollHeight - elementY < window.innerHeight
				? document.body.scrollHeight - window.innerHeight
				: elementY ) - 100;
		const diff = targetY - startingY;
		let start;

		if ( ! diff ) {
			return;
		}

		window.requestAnimationFrame( function step( timestamp ) {
			if ( ! start ) {
				start = timestamp;
			}
			const time = timestamp - start;
			const percent = Math.min( time / duration, 1 );
			window.scrollTo( 0, startingY + diff * percent );

			if ( time < duration ) {
				window.requestAnimationFrame( step );
			}
		} );
	}

	async submitForm(
		form,
		action,
		successCallback = null,
		from = '',
		additionalData = ''
	) {
		console.log('submitForm called with action:', action);
		const formData = new FormData( form );
		const checkedDonationFrequency = form.querySelector(
			'input[type="radio"][name="donation_frequency"]:checked'
		);
		const hiddenDonationFrequency = form.querySelector(
			'input[type="hidden"][name="donation_frequency"]'
		);
		const donationFrequency =
			checkedDonationFrequency?.value || hiddenDonationFrequency?.value;

		if ( donationFrequency ) {
			formData.set( 'donation_frequency', donationFrequency );
		}

		if ( donationFrequency === 'onetime' ) {
			formData.delete( 'donation_frequency_period' );
		}

		if ( typeof additionalData === 'object' ) {
			for ( const pair of additionalData.entries() ) {
				formData.append( pair[ 0 ], pair[ 1 ] );
			}
		}

		const customAmount = form.querySelector( '#custom_amount' );
		const selectedPredefinedAmount = form.querySelector(
			'.levcharity_form__donation_list.predefined_amount_wrapper > .selected'
		);

		let formFilesValid = true;

		const acceptFileSize = 10; // MB

		const size = 1024 * 1024 * acceptFileSize;

		if ( form.querySelector( 'input[type=file]' ) ) {
			form.querySelectorAll( 'input[type=file]' ).forEach( ( field ) => {
				for ( const file of field.files ) {
					if ( file.size > size ) {
						this.printValidation(
							form,
							wp.i18n.sprintf(
								/* translators: %1$s: File name, %2$s: Maximum file size in MB */
								wp.i18n.__(
									'"%1$s" size is too big, should be less than %2$sMB',
									'levcharity'
								),
								file.name,
								acceptFileSize
							)
						);
						formFilesValid = false;
					}
				}
			} );
		}

		const tributeCheckbox = form.querySelector('div.donation_tribute_checkbox input[type="checkbox"]');
		if(tributeCheckbox){
			formData.append('_donation_tribute_enabled', tributeCheckbox.checked);
		}

		this.appendWpmlLanguageToFormData( formData );

		if ( ! formFilesValid ) {
			//nothing to do
		} else if (
			! form.classList.contains( 'levcharity_event_multi_ticket_form' ) &&
			! form.classList.contains( 'levcharity_ticket_form' ) &&
			customAmount &&
			( customAmount.value == '' || customAmount.value == 0 ) &&
			! selectedPredefinedAmount
		) {
			this.printValidation(
				form,
				"You haven't add anything to your order."
			);
		} else {
			try {
				if ( action !== 'find_teams' ) {
					if (
						! document.body.classList.contains( 'ajax-loading' )
					) {
						document.body.classList.add( 'ajax-loading' );
					}
				}

				const excludeActions = [
					'levcharity_create_p2p_campaign',
					'levcharity_create_team',
					'levcharity_join_team',
					'levcharity_join_campaign',
				];

				const response = await fetch(
					`${ this.admin_ajax }` +
						( ! excludeActions.includes( action )
							? `?action=${ action }`
							: '' ),
					{
						method: 'POST',
						headers: ! excludeActions.includes( action )
							? {
									'Content-Type':
										'application/x-www-form-urlencoded',
							  }
							: {},
						body: ! excludeActions.includes( action )
							? new URLSearchParams( formData )
							: formData,
					}
				);

				const jsonResponse = await response.json();

				if (jsonResponse.hasOwnProperty('local_cart')) {
					localStorage.setItem('cart', JSON.stringify(jsonResponse.local_cart));
				}

				if ( response.status === 403 || jsonResponse.success === false ) {
					if ( document.body.classList.contains( 'ajax-loading' ) ) {
						document.body.classList.remove( 'ajax-loading' );
					}
					const errorMessage = jsonResponse.data?.message || jsonResponse.message || '';
					console.log('Form error response:', jsonResponse, 'Message:', errorMessage);
					this.printValidation(form, errorMessage);
					const errorContainer = document.querySelector(
						'.levcharity-errors-container'
					);
					if ( errorContainer ) {
						errorContainer.innerHTML = errorMessage;
					}
					return;
				} else {
					const redirectUrl = jsonResponse.hasOwnProperty(
						'redirect_url'
					)
						? jsonResponse.redirect_url
						: '';

					if ( redirectUrl !== '' ) {
						window.location.href = redirectUrl;
					}

					if (
						successCallback &&
						typeof successCallback === 'function'
					) {
						successCallback( jsonResponse );
					}
				}
			} catch ( error ) {
				console.log( error.message );
				if (
					from === 'donate-form' &&
					document.body.classList.contains( 'ajax-loading' )
				) {
					document.body.classList.remove( 'ajax-loading' );
				}
			} finally {
				if ( from !== 'donate-form' ) {
					if ( document.body.classList.contains( 'ajax-loading' ) ) {
						document.body.classList.remove( 'ajax-loading' );
					}
				}
			}
		}
	}

	watchTabs() {
		const lastTab = this.#allTabs[this.#allTabs.length - 1];
		if (lastTab.classList.contains('active')) {
			if ( this.#nextButton?.classList.contains( 'active' ) ) {
				this.#nextButton?.classList.remove( 'active' );
			}
			if ( ! this.#submitButton?.classList.contains( 'active' ) ) {
				this.#submitButton?.classList.add( 'active' );
			}
		}
		if ( ! this.#allTabs || ! this.#allNavs ) {
			return;
		}

		this.#allNavs.forEach( ( nav ) => {
			nav.addEventListener( 'click', () => {
				const index = Array.prototype.indexOf.call(
					nav.parentElement.children,
					nav
				);

				this.#allTabs.forEach( ( tab ) => {
					if ( tab.classList.contains( 'active' ) ) {
						tab.classList.remove( 'active' );
					}
				} );

				//Clear current active
				this.#allNavs.forEach( ( navItem ) => {
					if ( navItem.classList.contains( 'active' ) ) {
						navItem.classList.remove( 'active' );
					}
				} );

				if(this.#allTabs.length === index + 1){
					if ( this.#nextButton?.classList.contains( 'active' ) ) {
						this.#nextButton?.classList.remove( 'active' );
					}
					if ( ! this.#submitButton?.classList.contains( 'active' ) ) {
						this.#submitButton?.classList.add( 'active' );
					}
				}else {
					if ( this.#submitButton?.classList.contains( 'active' ) ) {
						this.#submitButton?.classList.remove( 'active' );
					}
					if ( ! this.#nextButton?.classList.contains( 'active' ) ) {
						this.#nextButton?.classList.add( 'active' );
					}
				}
				this.#tabIndex = index;
				//toggle back button visibility
				if ( index === 0 ) {
					if ( this.#backButton?.classList.contains( 'active' ) ) {
						this.#backButton?.classList.remove( 'active' );
					}
					if ( this.#submitButton?.classList.contains( 'active' ) ) {
						this.#submitButton?.classList.remove( 'active' );
					}
					if ( ! this.#nextButton?.classList.contains( 'active' ) ) {
						this.#nextButton?.classList.add( 'active' );
					}
				} else if ( index === 1 ) {
					if ( ! this.#backButton?.classList.contains( 'active' ) ) {
						this.#backButton?.classList.add( 'active' );
					}
				} else {
					if ( this.#nextButton?.classList.contains( 'active' ) ) {
						this.#nextButton?.classList.remove( 'active' );
					}
					if ( ! this.#backButton?.classList.contains( 'active' ) ) {
						this.#backButton?.classList.add( 'active' );
					}
					if (
						! this.#submitButton?.classList.contains( 'active' )
					) {
						this.#submitButton?.classList.add( 'active' );
					}
				}

				this.#allNavs[ index ]?.classList.add( 'active' );
				this.#allTabs[ index ]?.classList.add( 'active' );
				this.handleCustomFieldsVisibility();
			} );
		} );
	}

	watchNavigationButtons() {

		const isAnyTabActive = Array.from(this.#allTabs).some(tab => tab.classList.contains('active'));
		if (!isAnyTabActive) {
			this.#allNavs[0].classList.add('active');
			this.#allTabs[0].classList.add('active');
		}

		if(this.#allTabs.length === 1){
			if ( this.#nextButton?.classList.contains( 'active' ) ) {
				this.#nextButton?.classList.remove( 'active' );
			}
			if ( ! this.#submitButton?.classList.contains( 'active' ) ) {
				this.#submitButton?.classList.add( 'active' );
			}
		}
		this.#tabIndex = 0;
		this.#nextButton?.addEventListener( 'click', () => {
			this.#tabIndex++;
			let currentIndex;
			this.#allNavs.forEach( ( nav, index ) => {
				if ( nav.classList.contains( 'active' ) ) {
					currentIndex = index;
				}
			} );

			this.#allNavs[ currentIndex ].classList.remove( 'active' );
			this.#allNavs[ currentIndex + 1 ].classList.add( 'active' );
			this.#allTabs[ currentIndex ].classList.remove( 'active' );
			if(this.#allTabs[ currentIndex + 1 ]){
				this.#allTabs[ currentIndex + 1 ].classList.add( 'active' );
			}

			if(this.#allTabs.length === this.#tabIndex + 1){
				if ( this.#nextButton?.classList.contains( 'active' ) ) {
					this.#nextButton?.classList.remove( 'active' );
				}
				if ( ! this.#submitButton?.classList.contains( 'active' ) ) {
					this.#submitButton?.classList.add( 'active' );
				}
			}
			if ( currentIndex === 0 ) {
				if ( ! this.#backButton?.classList.contains( 'active' ) ) {
					this.#backButton?.classList.add( 'active' );
				}
			} else if ( currentIndex === 1 ) {
				if ( this.#nextButton?.classList.contains( 'active' ) ) {
					this.#nextButton?.classList.remove( 'active' );
				}
				if ( ! this.#submitButton?.classList.contains( 'active' ) ) {
					this.#submitButton?.classList.add( 'active' );
				}
			}
			this.handleCustomFieldsVisibility();
		} );

		this.#backButton?.addEventListener( 'click', () => {
			this.#tabIndex--;
			let currentIndex;
			this.#allNavs.forEach( ( nav, index ) => {
				if ( nav.classList.contains( 'active' ) ) {
					currentIndex = index;
				}
			} );

			this.#allNavs[ currentIndex ].classList.remove( 'active' );
			this.#allNavs[ currentIndex - 1 ].classList.add( 'active' );
			this.#allTabs[ currentIndex ].classList.remove( 'active' );
			this.#allTabs[ currentIndex - 1 ].classList.add( 'active' );

			if(this.#allTabs.length !== this.#tabIndex + 1){
				if ( this.#submitButton?.classList.contains( 'active' ) ) {
					this.#submitButton?.classList.remove( 'active' );
				}
				if ( ! this.#nextButton?.classList.contains( 'active' ) ) {
					this.#nextButton?.classList.add( 'active' );
				}
			}

			if ( currentIndex === 1 ) {
				if ( this.#backButton?.classList.contains( 'active' ) ) {
					this.#backButton?.classList.remove( 'active' );
				}
			} else if ( currentIndex === 2 ) {
				if ( this.#submitButton?.classList.contains( 'active' ) ) {
					this.#submitButton?.classList.remove( 'active' );
				}
				if ( ! this.#nextButton?.classList.contains( 'active' ) ) {
					this.#nextButton?.classList.add( 'active' );
				}
			}
			this.handleCustomFieldsVisibility();
		} );
	}

	watchQuantityInput = ( form, orderArray ) => {
		if ( ! form ) {
			return;
		}

		const allQuantityInputs = document.querySelectorAll(
			'.levcharity_form input.qty'
		);

		allQuantityInputs?.forEach( ( input ) => {
			input.addEventListener( 'input', () => {
				const parent = input.closest( 'li' );
				const productData = this.#buildOrderArray( form, parent );

				if ( orderArray.length === 0 && productData.quantity !== '0' ) {
					orderArray.push( productData );
				} else {
					const index = this.#helper.findObjectById(
						orderArray,
						productData.id
					);
					if ( index >= 0 ) {
						if ( productData.quantity !== '0' ) {
							// if found update quantity
							orderArray[ index ].quantity = productData.quantity;
						} else {
							//if quantity 0 remove
							orderArray.splice( index, 1 );
						}
					} else if ( productData.quantity !== '0' ) {
						//prevent from adding when clicking minus and quantity 0
						orderArray.push( productData );
					}
				}

				this.#clearSummaryTable( form );
				this.#createSummaryRows( form, orderArray );
				this.#clearSummaryTotal( form );
				this.#createSummaryTotal( form, orderArray );
			} );
		} );
	};

	watchQuantityButtons = ( form, orderArray ) => {
		if ( ! form ) {
			return;
		}

		//Watch + and - buttons
		const allQuantityButtons = document.querySelectorAll(
			'.levcharity_form .qty-button'
		);
		allQuantityButtons?.forEach( ( button ) => {
			button.addEventListener( 'click', ( event ) => {
				//Amend quantity button minus to allow 0 in the input
				if ( event.target.matches( '.qty-button-minus2' ) ) {
					const quantityDiv = event.target.closest( '.quantity' );
					const inputQty = quantityDiv.querySelector( 'input.qty' );
					if ( inputQty?.value > 0 ) {
						inputQty.value = parseInt( inputQty.value, 10 ) - 1;
						inputQty.setAttribute( 'value', inputQty.value );
					}
				}

				//Amend quantity button plus to allow max in the input
				if ( event.target.matches( '.qty-button-plus2' ) ) {
					const quantityDiv = event.target.closest( '.quantity' );
					const inputQty = quantityDiv?.querySelector( 'input.qty' );

					if ( inputQty ) {
						const currentValueRaw = inputQty.value ?? '0';
						const currentValue = parseInt( currentValueRaw, 10 );
						const safeCurrentValue = Number.isNaN( currentValue ) ? 0 : currentValue;
						const maxAttr = inputQty.getAttribute( 'max' );
						const parsedMax = maxAttr !== null && maxAttr !== '' ? parseInt( maxAttr, 10 ) : null;
						const canIncrement =
							parsedMax === null ||
							Number.isNaN( parsedMax ) ||
							parsedMax <= 0 ||
							safeCurrentValue < parsedMax;

						if ( canIncrement ) {
							inputQty.value = safeCurrentValue + 1;
							inputQty.setAttribute( 'value', inputQty.value );
						} else if ( parsedMax !== null && !Number.isNaN( parsedMax ) ) {
							inputQty.value = parsedMax;
							inputQty.setAttribute( 'value', inputQty.value );
						}
					}
				}

				const parent = button?.closest( 'li' );
				const productData = this.#buildOrderArray( form, parent );

				if ( orderArray.length === 0 && productData.quantity !== '0' ) {
					orderArray.push( productData );
				} else {
					const index = this.#helper.findObjectById(
						orderArray,
						productData.id
					);
					if ( index >= 0 ) {
						if ( productData.quantity !== '0' ) {
							// if found update quantity
							orderArray[ index ].quantity = productData.quantity;
						} else {
							//if quantity 0 remove
							orderArray.splice( index, 1 );
						}
					} else if ( productData.quantity !== '0' ) {
						//prevent from adding when clicking minus and quantity 0
						orderArray.push( productData );
					}
				}

				this.#clearSummaryTable( form );
				this.#createSummaryRows( form, orderArray );
				this.#clearSummaryTotal( form );
				this.#createSummaryTotal( form, orderArray );
			} );
		} );
	};

	fixDuplicatedFormFields = (
		checkboxWrapper,
		checkboxName,
		type = 'input'
	) => {
		const allElements = document.querySelectorAll(
			`.${ checkboxWrapper }`
		);
		if ( allElements.length > 1 ) {
			allElements.forEach( ( wrapper, index ) => {
				if ( index > 0 ) {
					const element = wrapper.querySelector( `${ type }` );
					element?.setAttribute(
						'id',
						`${ checkboxName }_${ index }`
					);
					const label = wrapper.querySelector( 'label' );
					label?.setAttribute(
						'for',
						`${ checkboxName }_${ index }`
					);
				}
			} );
		}
	};

	watchCheckboxes() {
		document.addEventListener( 'change', ( event ) => {
			if ( event.target.matches( 'input[name="gift_aid"]' ) ) {
				const parentWrapper = event.target.closest(
					'.donation_gift_aid_wrapper'
				);
				const description = parentWrapper?.querySelector(
					'.gift_aid_description'
				);
				if ( event.target.checked ) {
					description.style.display = 'block';
				} else {
					description.style.display = 'none';
				}
			}

			if ( event.target.matches( 'input[name="anonymous_donation"]' ) ) {
				const parent = event.target.closest( 'form' );
				const donorNameWrapper = parent?.querySelector(
					'.display_name_wrapper'
				);
				const donorNameInput = parent?.querySelector(
					'input[name="display_name"]'
				);

				if ( event.target.checked ) {
					if ( donorNameWrapper ) {
						donorNameWrapper.style.display = 'none';
					}
					if ( donorNameInput ) {
						donorNameInput.value = '';
					}
				} else {
					if ( donorNameWrapper ) {
						donorNameWrapper.style.display = 'block';
					}
					if ( donorNameInput ) {
						donorNameInput.value = '';
					}
				}
			}
		} );
	}

	setCurrencySymbolForDonationAmount = ( form ) => {
		if ( ! form ) {
			return;
		}
		const donationWrapper = form.querySelector(
			'.levcharity_form__donation_amount_wrapper'
		);

		if ( ! donationWrapper ) {
			return;
		}
		const allDonationCurrencySymbols =
			donationWrapper.querySelectorAll( '.currency_symbol' );

		const currencySymbol = donationWrapper.dataset.currencysymbol;
		// if (! form.dataset.hideswitcher && donationWrapper.dataset.localesymbol) {
		// 	currencySymbol = donationWrapper.dataset.localesymbol;
		// }

		allDonationCurrencySymbols?.forEach( ( span ) => {
			span.textContent = currencySymbol;
		} );
	};

	#clearPredefinedAmounts = ( form ) => {
		if ( ! form ) {
			return;
		}

		const predefinedAmounts = form.querySelectorAll( '.predefined_amount' );

		predefinedAmounts?.forEach( ( amount ) => {
			if ( amount.classList.contains( 'selected' ) ) {
				amount.classList.remove( 'selected' );
				const input = amount.querySelector(
					'input[name="predefined_amount"]'
				);
				input.checked = false;
				input.value = '';
			}
		} );
	};

	#buildOrderArray = ( form, parent ) => {
		if ( ! form || ! parent ) {
			return;
		}
		let price = parent.dataset.price;
		let priceWithoutFee = parent.dataset.price;
		const equipment = parent.classList.contains('donation_equipment_product') ? 1 : 0;
		const donationFrequency = form.querySelector('.donation_frequency_wrapper');
		const feeCheckbox = form.querySelector( 'input[name="cc_fee"]' );
		const ccFeeValue = form.querySelector('input[name="cc_fee_percentage"]');
		let currenySwitcherSymbol = '';

		const currencySwitcher = form.querySelector('select[name="user_paying_currency"]');
		if ( currencySwitcher ) {
			currenySwitcherSymbol = currencySwitcher.dataset.currencysymbol;
		}

		const currencyConversion = form.querySelector(
			'input[name="currency_conversion"]'
		);

		if ( feeCheckbox?.checked ) {
			price =
				Number( parent?.dataset.price ) +
				( Number( parent?.dataset.price ) *
					Number( ccFeeValue.value ) ) /
					100;
		}

		if ( parent.classList.contains( 'advance_event_digital_ad' ) ) {
			const currentCurrency = form.dataset.basecurrency;
			// Try currency-specific price (uppercase as set in PHP: data-price-CAD)
			let productPrice = parent.getAttribute(
				`data-price-${ currentCurrency.toUpperCase() }`
			);
			// Fallback to base data-price if currency-specific doesn't exist
			if ( ! productPrice || productPrice === '' || productPrice === 'null' ) {
				productPrice = parent.dataset.price;
			}

			if ( feeCheckbox?.checked ) {
				price =
					Number( productPrice ) +
					( Number( productPrice ) * Number( ccFeeValue.value ) ) /
						100;
			} else {
				price = Number( productPrice ) || 0;
			}

			priceWithoutFee = Number( productPrice ) || 0;
		} else if (parent.classList.contains( 'donation_equipment_product' )) {
			const currentCurrency =
				form.querySelector( 'select[name="user_paying_currency"]' )
					?.value ?? form.dataset.basecurrency;

			const productPrice = parent.getAttribute(
				`data-price-${ currentCurrency }`
			);

			if ( feeCheckbox?.checked ) {
				price =
					Number( productPrice ) +
					( Number( productPrice ) * Number( ccFeeValue.value ) ) /
						100;
			} else {
				price = Number( productPrice );
			}

			priceWithoutFee = Number( productPrice );
		} else if (parent.classList.contains( 'predefined_amount' ) || parent.classList.contains( 'custom_amount' )) {
			if ( feeCheckbox?.checked && parent.dataset.price ) {
				price =
					Number( parent?.dataset.price ) +
					( Number( parent?.dataset.price ) *
						Number( ccFeeValue.value ) ) /
						100;
			} else if ( ! feeCheckbox?.checked && parent.dataset.price ) {
				price = parent?.dataset.price;
			} else if ( feeCheckbox?.checked && ! parent.dataset.price ) {
				price =
					Number( parent.querySelector( 'input' )?.value ) +
					( Number( parent.querySelector( 'input' )?.value ) *
						Number( ccFeeValue.value ) ) /
						100;
				priceWithoutFee = Number(
					parent.querySelector( 'input' )?.value
				);
			} else {
				price = parent.querySelector( 'input' )?.value;
				priceWithoutFee = Number(
					parent.querySelector( 'input' )?.value
				);
			}

			let subname = '';
			if (
				donationFrequency &&
				donationFrequency.dataset.donationfrequency ===
					wp.i18n.__( 'One-time', 'levcharity' )
			) {
				subname = wp.i18n.__( 'One-time', 'levcharity' );
			} else if (
				donationFrequency &&
				donationFrequency.dataset.donationfrequency ===
					wp.i18n.__( 'Monthly', 'levcharity' )
			) {
				subname = wp.i18n.__( 'Monthly', 'levcharity' );
			}

			if ( parent.classList.contains( 'custom_amount' ) ) {
				currenySwitcherSymbol =
					parent.querySelector( '.currency_symbol' )?.innerText;
			}

			return {
				id: parent.dataset.id,
				name: wp.i18n.__( 'Donation', 'levcharity' ),
				subname,
				quantity: 1,
				price,
				priceWithoutFee,
				defaultprice: parent.dataset.price ?? '',
				currency: parent.dataset.currency,
				currency_symbol: currenySwitcherSymbol
					? currenySwitcherSymbol
					: parent.dataset.currencysymbol,
				equipment,
			};
		}

		return {
			id: parent.dataset.id,
			name: parent.dataset.name,
			subname: '',
			quantity: parent.querySelector( 'input.qty' ).value,
			price,
			priceWithoutFee,
			defaultprice: parent.dataset.price ?? '',
			currency: parent.dataset.currency,
			currency_symbol: parent.dataset.currencysymbol,
			equipment,
		};
	};

	#clearSummaryTable = ( form ) => {
		if ( ! form ) {
			return;
		}

		if ( form.querySelector( '.levcharity_form__summary_list tbody' ) ) {
			form.querySelector(
				'.levcharity_form__summary_list tbody'
			).innerHTML = '';
		}
	};

	#createSummaryRows = ( form, orderArray ) => {
		if ( ! form ) {
			return;
		}

		if ( form.querySelector( '.levcharity_form__summary' ) ) {
			form.querySelector( '.levcharity_form__summary' ).style.display =
				'block';
		}

		orderArray?.forEach( ( product ) => {
			const row = this.#createSummaryRow( product, form );
			if (
				form.querySelector( '.levcharity_form__summary_list tbody' )
			) {
				form.querySelector(
					'.levcharity_form__summary_list tbody'
				).append( row );
			}
		} );
	};

	#createSummaryRow = ( product, form ) => {
		const row = document.createElement( 'tr' );
		const rounding = form?.dataset.rounding;

		const tdProduct = document.createElement( 'td' );
		tdProduct.classList.add( 'product_name' );

		if ( product.name === wp.i18n.__( 'Donation', 'levcharity' ) ) {
			const subname = document.createElement( 'span' );
			subname.classList.add( 'product_subname' );
			subname.append( product.subname );
			tdProduct.append( product.name, subname );
		} else {
			tdProduct.append( product.name );
		}

		const tdQuantity = document.createElement( 'td' );
		tdQuantity.classList.add( 'product_quantity' );
		tdQuantity.append( product.quantity );

		const tdPriceWrapper = document.createElement( 'td' );
		tdPriceWrapper.classList.add( 'product_price_wrapper' );

		const tdCurrency = document.createElement( 'span' );
		tdCurrency.classList.add( 'product_currency' );
		tdCurrency.append( product.currency_symbol );

		const tdPrice = document.createElement( 'span' );
		tdPrice.classList.add( 'product_price' );
		if ( rounding ) {
			tdPrice.append(
				Math.ceil( Number( product.price ) ).toLocaleString( 'en-US', {
					minimumFractionDigits: 0,
					maximumFractionDigits: 0,
				} )
			);
		} else {
			tdPrice.append(
				Number( product.price ).toLocaleString( 'en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				} )
			);
		}

		tdPriceWrapper.append( tdCurrency, tdPrice );

		const tdRemove = document.createElement( 'td' );
		const tdDelete = document.createElement( 'a' );
		tdDelete.setAttribute( 'href', '#' );
		tdDelete.setAttribute( 'data-productid', product.id );
		tdDelete.classList.add( 'delete_product' );
		tdDelete.append( 'X' );

		tdRemove.append( tdDelete );

		row.append( tdProduct, tdQuantity, tdPriceWrapper, tdRemove );
		return row;
	};

	#clearSummaryTotal = ( form ) => {
		if ( ! form ) {
			return;
		}

		if ( form.querySelector( '.levcharity_form__summary_list tfoot' ) ) {
			form.querySelector(
				'.levcharity_form__summary_list tfoot'
			).innerHTML = '';
		}
	};

	#createSummaryTotal = ( form, orderArray ) => {
		if ( ! form ) {
			return;
		}

		const sticky_bar_total_amount = document.querySelector(
			'.donation_form_sticky_bar .selected_amount'
		);
		if ( sticky_bar_total_amount ) {
			let total = document.querySelector( '.predefined_amount.selected' );
			if ( total ) {
				total = total.querySelector(
					'input[name="predefined_amount"]'
				).value;
			} else if ( ! total ) {
				total = document.querySelector( '#custom_amount' );
				total = total.value;
			}
			if ( total > 0 ) {
				if ( this.#stickyBarSubmitButton ) {
					this.#stickyBarSubmitButton.removeAttribute( 'disabled' );
				}
			} else if ( this.#stickyBarSubmitButton ) {
				this.#stickyBarSubmitButton.setAttribute( 'disabled', 'true' );
			}

			if(orderArray){
				sticky_bar_total_amount.innerText =
					orderArray[ 0 ].currency_symbol + total;
			}
		}

		const formSummary = form.querySelector( '.levcharity_form__summary' );
		const formFooter = form.querySelector(
			'.levcharity_form__summary_list tfoot'
		);
		if ( orderArray.length > 0 ) {
			const totalRow = this.#createSummaryTotalRow( orderArray, form );
			formFooter?.append( totalRow );
			if ( formSummary ) {
				formSummary.style.display = 'block';
			}
		} else if ( orderArray.length === 0 ) {
			if ( formSummary ) {
				formSummary.style.display = 'none';
			}
		}
	};

	#createSummaryTotalRow = ( orderArray, form ) => {
		const rounding = form?.dataset.rounding;
		const row = document.createElement( 'tr' );

		const tdTotal = document.createElement( 'td' );
		tdTotal.setAttribute( 'colspan', '4' );

		const subtotals = [];

		orderArray.forEach( ( product ) => {
			const subtotal =
				Number( product.price ) * Number( product.quantity );
			subtotals.push( subtotal );
		} );

		let total = subtotals.reduce(
			( totalAmount, currentNumber ) => totalAmount + currentNumber,
			0
		);

		if ( total === 0 ) {
			// translators: %s will be replaced by the total amount.
			tdTotal.append( wp.i18n.__( 'Total: Free', 'levcharity' ) );
		} else {
			if ( rounding ) {
				total = Math.ceil( total ).toLocaleString( 'en-US', {
					minimumFractionDigits: 0,
					maximumFractionDigits: 0,
				} );
			} else {
				total = total.toLocaleString( 'en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				} );
			}

			tdTotal.append(
				wp.i18n.sprintf(
					/* translators: %1$s: Currency symbol, %2$s: Total amount */
					wp.i18n.__( 'Total: %1$s %2$s', 'levcharity' ),
					orderArray[ 0 ].currency_symbol,
					total
				)
			);
		}

		row.append( tdTotal );

		return row;
	};

	#clearCustomAmount = ( form ) => {
		if ( ! form ) {
			return;
		}
		const customAmount = form.querySelector(
			'input[name="custom_amount"]'
		);
		customAmount.value = '';
	};

	#clearQuantityInput = ( id ) => {
		const input = document.getElementById( 'quantity_' + id );
		if ( input ) {
			input.value = 0;
		}
	};

	removeFromSummaryTable = ( form, orderArray ) => {
		document.addEventListener( 'click', ( event ) => {
			if ( event.target.matches( '.delete_product' ) ) {
				const productID = event.target.dataset.productid;
				const index = this.#helper.findObjectById(
					orderArray,
					productID
				);

				if (
					orderArray.length > 0 && orderArray[ index ].name === wp.i18n.__( 'Donation', 'levcharity' )) {
					this.#clearPredefinedAmounts( form );
					this.#clearCustomAmount( form );
				} else {
					this.#clearQuantityInput( productID );
				}

				orderArray.splice( index, 1 );

				this.#clearSummaryTable( form );
				this.#createSummaryRows( form, orderArray );
				this.#clearSummaryTotal( form );
				this.#createSummaryTotal( form, orderArray );
			}
		} );
	};

	selectDonationAmount = ( form, orderArray ) => {
		if ( ! form ) {
			return;
		}

		const predefinedAmounts = form.querySelectorAll( '.predefined_amount' );
		const customAmount = form.querySelector(
			'input[name="custom_amount"]'
		);

		predefinedAmounts?.forEach( ( donation ) => {
			donation.addEventListener( 'click', ( event ) => {
				let selected = 0;
				//This click provide two events (label and input)
				if ( event.target.nodeName === 'INPUT' ) {
					if(customAmount) customAmount.value = '';
					const input = event.target;
					const parent = input.closest( 'div' );
					if ( parent?.classList.contains( 'selected' ) ) {
						parent.classList.remove( 'selected' );
						input.checked = false;
						input.value = '';
						selected = 0;
					} else {
						this.#clearPredefinedAmounts( form );
						parent?.classList.add( 'selected' );
						input.checked = true;
						input.value = input.dataset.value;
						selected = 1;
					}
				}

				const productData = this.#buildOrderArray( form, donation );

				if (
					orderArray.length === 0 &&
					event.target.nodeName === 'INPUT'
				) {
					orderArray.push( productData );
				} else if (
					orderArray.length > 0 &&
					event.target.nodeName === 'INPUT'
				) {
					const index = this.#helper.findObjectById(
						orderArray,
						productData.id
					);

					if ( index === -1 ) {
						orderArray.push( productData );
					} else if (
						index >= 0 &&
						productData.quantity !== '0' &&
						selected === 1
					) {
						orderArray[ index ].price = productData.price;
						orderArray[ index ].priceWithoutFee =
							donation.dataset.price;
					} else if (
						index >= 0 &&
						productData.quantity !== '0' &&
						selected === 0
					) {
						//if un-clicked remove
						orderArray.splice( index, 1 );
					}
				}

				this.#clearSummaryTable( form );
				this.#createSummaryRows( form, orderArray );
				this.#clearSummaryTotal( form );
				this.#createSummaryTotal( form, orderArray );
			} );
		} );

		customAmount?.addEventListener( 'change', ( event ) => {
			const parent = event.target.closest( '.custom_amount' );
			const productData = this.#buildOrderArray( form, parent );

			if ( orderArray.length === 0 ) {
				orderArray.push( productData );
			} else {
				const index = this.#helper.findObjectById(
					orderArray,
					productData.id
				);

				if ( index === -1 ) {
					orderArray.push( productData );
				} else if ( index >= 0 && productData.quantity !== '0' ) {
					orderArray[ index ].price = productData.price;
					orderArray[ index ].priceWithoutFee = productData.price;
				} else if ( index >= 0 && productData.quantity !== '0' ) {
					//if un-clicked remove
					orderArray.splice( index, 1 );
				}
			}

			this.#clearSummaryTable( form );
			this.#createSummaryRows( form, orderArray );
			this.#clearSummaryTotal( form );
			this.#createSummaryTotal( form, orderArray );
		} );

		customAmount?.addEventListener( 'focus', () => {
			this.#clearPredefinedAmounts( form );
		} );
	};

	watchCCFeeCheckbox = ( form, orderArray ) => {
		if ( ! form ) {
			return;
		}

		const baseCurrency = form.dataset.basecurrency;
		const checkbox = form.querySelector( 'input[name="cc_fee"]' );
		const ccFeeValue = form.querySelector(
			'input[name="cc_fee_percentage"]'
		);
		const currencyConversion = form.querySelector(
			'input[name="currency_conversion"]'
		);

		checkbox?.addEventListener( 'click', ( event ) => {
			if ( event.target.checked && orderArray.length > 0 ) {
				orderArray?.forEach( ( product ) => {
					if (
						product.name === wp.i18n.__( 'Donation', 'levcharity' )
					) {
						product.price =
							Number( product.priceWithoutFee ) +
							( Number( product.priceWithoutFee ) *
								Number( ccFeeValue.value ) ) /
								100;
					} else if (
						product.name !==
							wp.i18n.__( 'Donation', 'levcharity' ) &&
						baseCurrency === product.currency &&
						product.equipment !== 1
					) {
						product.price =
							Number( product.defaultprice ) +
							( Number( product.defaultprice ) *
								Number( ccFeeValue.value ) ) /
								100;
					} else if ( product.equipment === 1 ) {
						product.price =
							Number( product.price ) +
							( Number( product.price ) *
								Number( ccFeeValue.value ) ) /
								100;
					} else {
						product.price =
							Number( product.defaultprice ) *
								Number( currencyConversion.value ) +
							( Number( product.defaultprice ) *
								Number( currencyConversion.value ) *
								Number( ccFeeValue.value ) ) /
								100;
					}
				} );
			} else {
				orderArray?.forEach( ( product ) => {
					if (
						product.name ===
							wp.i18n.__( 'Donation', 'levcharity' ) ||
						product.equipment === 1
					) {
						product.price = product.priceWithoutFee;
					} else if (
						product.name !==
							wp.i18n.__( 'Donation', 'levcharity' ) &&
						baseCurrency === product.currency
					) {
						product.price = Number( product.defaultprice );
					} else {
						product.price =
							Number( product.defaultprice ) *
							Number( currencyConversion.value );
					}
				} );
			}

			this.#clearSummaryTable( form );
			this.#createSummaryRows( form, orderArray );
			this.#clearSummaryTotal( form );
			this.#createSummaryTotal( form, orderArray );
		} );
	};

	#setCurrencyConversion( form, input, rates ) {
		const baseCurrency = form.dataset.basecurrency;
		const localeCurrency = form.dataset.localecurrency;
		const hideSwitcher = form.dataset.hideswitcher;
		if (
			! hideSwitcher &&
			localeCurrency &&
			localeCurrency !== baseCurrency &&
			rates
		) {
			input.value = rates[ localeCurrency ] ?? 1;
		}
	}

	#toggleGiftAidVisibility( form, currency ) {
		const giftAidWrapper = form.querySelector(
			'.donation_gift_aid_wrapper'
		);
		const giftAidInput = form.querySelector( 'input[name="gift_aid"]' );
		if ( giftAidInput && giftAidWrapper ) {
			if ( 'GBP' === currency ) {
				if ( giftAidWrapper.classList.contains( 'hidden' ) ) {
					giftAidWrapper.classList.remove( 'hidden' );
				}
			} else if ( ! giftAidWrapper.classList.contains( 'hidden' ) ) {
				giftAidWrapper.classList.add( 'hidden' );
				if ( giftAidInput ) {
					giftAidInput.checked = false;
				}
			}
		}
	}

	donationCurrencySwitcher = ( form, orderArray, ratesArray ) => {
		if ( ! form ) {
			return;
		}

		const select = form.querySelector(
			'select[name="user_paying_currency"]'
		);

		const allOptions = select?.querySelectorAll( 'option' );

		const currencyConversion = form.querySelector(
			'input[name="currency_conversion"]'
		);

		const total_amount = document.querySelector('.donation_form_sticky_bar .total_sum .selected_amount');


		const baseCurrency = form.dataset.basecurrency;
		this.#toggleGiftAidVisibility( form, baseCurrency );

		this.#setCurrencyConversion( form, currencyConversion, ratesArray );

		if ( select?.value && allOptions.length > 0 ) {
			allOptions.forEach( ( option ) => {
				if ( option.value === select.value ) {
					select.dataset.currencysymbol = option.dataset.symbol;
					if(total_amount){
						total_amount.innerText = option.dataset.symbol + 0
					}
				}
			} );
		}

		select?.addEventListener( 'change', ( event ) => {
			this.#toggleGiftAidVisibility( form, event.target.value );

			allOptions.forEach( ( option ) => {
				if ( option.hasAttribute( 'selected' ) ) {
					option.removeAttribute( 'selected' );
				}
			} );
			event.target.options[
				event.target.options.selectedIndex
			].setAttribute( 'selected', 'selected' );

			if ( ratesArray ) {
				currencyConversion.value =
					ratesArray[
						event.target.options[ event.target.selectedIndex ].value
					] ?? 1;
			}

			const selectedSymbol =
				event.target.options[ event.target.selectedIndex ].dataset
					.symbol;

			select.dataset.currencysymbol = selectedSymbol;

			const allDonationCurrencySymbols = form.querySelectorAll(
				'.levcharity_form__donation_amount_wrapper .currency_symbol'
			);

			allDonationCurrencySymbols?.forEach( ( span ) => {
				span.textContent = selectedSymbol;
			} );

			const allPredefinedAmounts = form.querySelectorAll(
				'.levcharity_form__donation_amount_wrapper .predefined_amount'
			);

			allPredefinedAmounts?.forEach( ( amount ) => {
				amount.dataset.currencysymbol = selectedSymbol;
			} );

			const customAmount = form.querySelector(
				'.levcharity_form__donation_amount_wrapper .custom_amount'
			);

			if ( customAmount ) {
				customAmount.dataset.currencysymbol = selectedSymbol;
			}

			if ( orderArray.length > 0 ) {
				orderArray[ 0 ].currency_symbol = selectedSymbol;

				this.#clearSummaryTable( form );
				this.#createSummaryRows( form, orderArray );
				this.#clearSummaryTotal( form );
				this.#createSummaryTotal( form, orderArray );
			}
		} );
	};

	watchRecurringInputs = ( form, orderArray ) => {
		if ( ! form ) {
			return;
		}

		const donationFrequencyWrapper = form.querySelector(
			'.donation_frequency_wrapper'
		);
		const donationFrequencyInputs = form.querySelectorAll(
			'input[name="donation_frequency"]'
		);
		const donationFrequencySelect = form.querySelector(
			'.select_month_frequency'
		);

		donationFrequencyInputs?.forEach( ( input ) => {
			input.addEventListener( 'change', ( event ) => {
				if (
					event.target.value === 'monthly' &&
					orderArray.length > 0
				) {
					donationFrequencyWrapper.dataset.donationfrequency =
						wp.i18n.__( 'Monthly', 'levcharity' );
					donationFrequencySelect.style.display = 'block';

					orderArray[ 0 ].subname = wp.i18n.__(
						'Monthly',
						'levcharity'
					);

					this.#clearSummaryTable( form );
					this.#createSummaryRows( form, orderArray );
					this.#clearSummaryTotal( form );
					this.#createSummaryTotal( form, orderArray );
				} else if (
					event.target.value === 'onetime' &&
					orderArray.length > 0
				) {
					donationFrequencyWrapper.dataset.donationfrequency =
						wp.i18n.__( 'One-time', 'levcharity' );
					donationFrequencySelect.style.display = 'none';

					orderArray[ 0 ].subname = wp.i18n.__(
						'One-time',
						'levcharity'
					);

					this.#clearSummaryTable( form );
					this.#createSummaryRows( form, orderArray );
					this.#clearSummaryTotal( form );
					this.#createSummaryTotal( form, orderArray );
				} else if (
					event.target.value === 'onetime' &&
					orderArray.length === 0
				) {
					donationFrequencyWrapper.dataset.donationfrequency =
						wp.i18n.__( 'One-time', 'levcharity' );
					donationFrequencySelect.style.display = 'none';
				} else if (
					event.target.value === 'monthly' &&
					orderArray.length === 0
				) {
					donationFrequencyWrapper.dataset.donationfrequency =
						wp.i18n.__( 'Monthly', 'levcharity' );
					donationFrequencySelect.style.display = 'block';
				}
			} );
		} );
	};

	#getTributeElements( form ) {
		if ( ! form ) {
			return;
		}

		let switcherValue = '';
		const typeSwitcher = form?.querySelector('.donation-tribute-switcher')
		if(typeSwitcher){
			if(typeSwitcher.classList.contains("physically_tribute")){
				switcherValue = 'phyiscally_tribute';
			}else{
				switcherValue = 'electronically_value';
			}
		}
		if(switcherValue === 'physically_tribute' || switcherValue === '') {
			const checkbox = form.querySelector( '.donation_tribute' );
			const donationTributeName = form.querySelector(
				'.donation_tribute_name'
			);
			const donationTributeReceiver = form.querySelector(
				'.donation_tribute_receiver'
			);
			const donationTributeCertificateName = form.querySelector(
				'.donation_tribute_certificate_name'
			);
			const donationTributeCertificateEmail = form.querySelector(
				'.donation_tribute_certificate_email'
			);
			const donationTributePhysicalAddress = form.querySelector(
				'.donation_tribute_physical_address'
			);
			const donationTributeWrapper = form.querySelector(
				'.donation_tribute_wrapper'
			);
			const donationTributeType = Array.from(
				form.querySelectorAll( 'select[id^="donation_tribute_type"]' )
			).find( ( select ) => select.offsetParent !== null && ! select.disabled );

			return {
				checkbox,
				donationTributeName,
				donationTributeReceiver,
				donationTributeCertificateName,
				donationTributeCertificateEmail,
				donationTributePhysicalAddress,
				donationTributeWrapper,
				donationTributeType,
			};
		}else{
			return {}
		}

	}

	watchTributeCheckbox = ( form ) => {
		const elements = this.#getTributeElements( form );

		if ( ! elements ) {
			return;
		}

		const {
			checkbox,
			donationTributeWrapper,
			donationTributeName,
			donationTributeReceiver,
			donationTributeCertificateName,
			donationTributeCertificateEmail,
		} = elements;

		checkbox?.addEventListener( 'click', ( event ) => {
			if ( event.target.checked ) {
				donationTributeWrapper.style.display = 'block';
			} else {
				donationTributeWrapper.style.display = 'none';
				if ( donationTributeName ) donationTributeName.value = '';
				if ( donationTributeReceiver ) donationTributeReceiver.value = '';
				if ( donationTributeCertificateName ) donationTributeCertificateName.value = '';
				if ( donationTributeCertificateEmail ) donationTributeCertificateEmail.value = '';
				const physicalAddress = form.querySelector( '.donation_tribute_physical_address' );
				if ( physicalAddress ) physicalAddress.value = '';
			}
		} );
	};

	#addNoValidClass( inputElement ) {
		if (
			inputElement.value === '' &&
			! inputElement.classList.contains( 'no-valid' )
		) {
			inputElement.classList.add( 'no-valid' );
		}
	}

	#removeNoValidClass( inputElement ) {
		if (
			inputElement.value !== '' &&
			inputElement.classList.contains( 'no-valid' )
		) {
			inputElement.classList.remove( 'no-valid' );
		}
	}

	validateTribute( form ) {
		if ( ! form ) {
			return;
		}

		const hideDonationTribute = form.dataset.hidetribute;
		if ( hideDonationTribute ) {
			return true;
		}

		const elements = this.#getTributeElements( form );

		if ( ! elements ) {
			return;
		}

		const {
			checkbox,
			donationTributeName,
			donationTributeReceiver,
			donationTributeCertificateName,
			donationTributeCertificateEmail,
			donationTributePhysicalAddress,
			donationTributeType,
		} = elements;

		if ( ! checkbox || ! checkbox.checked ) {
			return true;
		}

		const tributeMessageMaxLength = parseInt(
			form.querySelector( '.donation-tribute-container' )?.dataset?.tributeMessageMaxLength || '250',
			10
		);

		if (
			donationTributeType &&
			! donationTributeType.classList.contains( 'no-validate' ) &&
			( donationTributeType.value === 'default' || donationTributeType.value === '' || donationTributeType.value === 'Select dedication' || donationTributeType.value === 'Select one' )
		) {
			donationTributeType.focus();
			this.printValidation(
				form,
				wp.i18n.__( 'Select Dedication is a required field.', 'levcharity' )
			);
			return false;
		}

		if (
			donationTributeCertificateName &&
			donationTributeCertificateName.value === ''
		) {
			this.#addNoValidClass( donationTributeCertificateName );
			this.printValidation(
				form,
				wp.i18n.__( 'FROM - Your name(s) is a required field.', 'levcharity' )
			);
			return false;
		}

		if (
			donationTributeReceiver &&
			donationTributeReceiver.value === ''
		) {
			this.#addNoValidClass( donationTributeReceiver );
			const isAltLocale = this.#isAltLocale( form );
			const fieldLabel = isAltLocale
				? wp.i18n.__( 'Honouree Name', 'levcharity' )
				: wp.i18n.__( 'Honoree Name', 'levcharity' );
			this.printValidation(
				form,
				fieldLabel + ' ' + wp.i18n.__( 'is a required field.', 'levcharity' )
			);
			return false;
		}

		if (
			donationTributeName &&
			donationTributeName.value === ''
		) {
			this.#addNoValidClass( donationTributeName );
			return false;
		}

		if (
			donationTributePhysicalAddress &&
			donationTributePhysicalAddress.offsetParent !== null &&
			donationTributePhysicalAddress.value.trim() === ''
		) {
			this.#addNoValidClass( donationTributePhysicalAddress );
			this.printValidation(
				form,
				wp.i18n.__( 'Mailing Address is a required field.', 'levcharity' )
			);
			return false;
		}

		if (
			donationTributeCertificateEmail &&
			donationTributeCertificateEmail.offsetParent !== null &&
			donationTributeCertificateEmail.value === ''
		) {
			this.#addNoValidClass( donationTributeCertificateEmail );
			const isAltLocale = this.#isAltLocale( form );
			const fieldLabel = isAltLocale
				? wp.i18n.__( 'Honouree Email', 'levcharity' )
				: wp.i18n.__( 'Honoree Email', 'levcharity' );
			this.printValidation(
				form,
				fieldLabel + ' ' + wp.i18n.__( 'is a required field.', 'levcharity' )
			);
			return false;
		}

		const tributeMessageFields = form.querySelectorAll(
			'.donation_tribute_certificate_message, .donation_tribute_card_message'
		);
		for ( const messageField of tributeMessageFields ) {
			if (
				messageField.offsetParent !== null &&
				messageField.value.length > tributeMessageMaxLength
			) {
				this.#addNoValidClass( messageField );
				this.printValidation(
					form,
					wp.i18n.sprintf(
						wp.i18n.__( 'Personal message cannot exceed %d characters.', 'levcharity' ),
						tributeMessageMaxLength
					)
				);
				return false;
			}
		}

		return true;
	}

	#isAltLocale( form ) {
		const currencySelect = form?.querySelector( '[name="user_paying_currency"]' );
		const currency = currencySelect?.value || form?.dataset?.currency || form?.dataset?.basecurrency || '';
		return [ 'GBP', 'CAD' ].includes( currency.toUpperCase() );
	}

	watchValidatedTributeInput( form ) {
		if ( ! form ) {
			return;
		}

		const elements = this.#getTributeElements( form );

		if ( ! elements ) {
			return;
		}

		const {
			donationTributeName,
			donationTributeReceiver,
			donationTributeCertificateName,
			donationTributeCertificateEmail,
			donationTributePhysicalAddress,
		} = elements;

		donationTributeName?.addEventListener( 'input', ( event ) => {
			this.#removeNoValidClass( event.target );
		} );

		donationTributeReceiver?.addEventListener( 'input', ( event ) => {
			this.#removeNoValidClass( event.target );
		} );

		donationTributeCertificateName?.addEventListener(
			'input',
			( event ) => {
				this.#removeNoValidClass( event.target );
			}
		);

		donationTributeCertificateEmail?.addEventListener(
			'input',
			( event ) => {
				this.#removeNoValidClass( event.target );
			}
		);

		donationTributePhysicalAddress?.addEventListener(
			'input',
			( event ) => {
				this.#removeNoValidClass( event.target );
			}
		);
	}


	//This solution is not used. It was designed to work with currency conversion
	watchProductCurrencySwitcher = ( form, orderArray, ratesArray ) => {
		if ( ! form ) {
			return;
		}

		const rounding = form.dataset.rounding;

		const select = form.querySelector(
			'select[name="user_paying_currency"]'
		);
		const currencyConversion = form.querySelector(
			'input[name="currency_conversion"]'
		);
		const checkbox = form.querySelector( 'input[name="cc_fee"]' );
		const ccFeeValue = form.querySelector(
			'input[name="cc_fee_percentage"]'
		);


		select?.addEventListener( 'change', ( event ) => {
			const allOptions = select?.querySelectorAll( 'option' );
			allOptions.forEach( ( option ) => {
				if ( option.hasAttribute( 'selected' ) ) {
					option.removeAttribute( 'selected' );
				}
			} );
			event.target.options[
				event.target.options.selectedIndex
			].setAttribute( 'selected', 'selected' );

			currencyConversion.value =
				ratesArray[
					event.target.options[ event.target.selectedIndex ].text
				];

			const selectedSymbol =
				event.target.options[ event.target.selectedIndex ].dataset
					.symbol;

			const allProductsCurrencySymbols = form.querySelectorAll(
				'.levcharity_form__products_item .currency_symbol'
			);

			allProductsCurrencySymbols?.forEach( ( span ) => {
				span.textContent = selectedSymbol;
			} );



			const allProducts = form.querySelectorAll(
				'.levcharity_form__products_item'
			);

			allProducts.forEach( ( product ) => {
				product.dataset.currencysymbol = selectedSymbol;
				const price = product.querySelector( '.product_price' );
				if ( rounding ) {
					price.textContent = Math.ceil(
						Number( product.dataset.price ) *
							Number( currencyConversion.value )
					).toLocaleString( 'en-US', {
						maximumFractionDigits: 2,
					} );
				} else {
					price.textContent = (
						Number( product.dataset.price ) *
						Number( currencyConversion.value )
					).toLocaleString( 'en-US', {
						maximumFractionDigits: 2,
					} );
				}
			} );

			if ( orderArray.length > 0 ) {
				orderArray.forEach( ( product ) => {
					product.currency_symbol = selectedSymbol;

					if ( checkbox?.checked ) {
						product.price =
							Number( product.defaultprice ) *
								Number( currencyConversion.value ) +
							( Number( product.defaultprice ) *
								Number( currencyConversion.value ) *
								Number( ccFeeValue.value ) ) /
								100;
					} else {
						product.price =
							Number( product.defaultprice ) *
							Number( currencyConversion.value );
					}
				} );

				this.#clearSummaryTable( form );
				this.#createSummaryRows( form, orderArray );
				this.#clearSummaryTotal( form );
				this.#createSummaryTotal( form, orderArray );
			}
		} );
	};

	enableSubmit( submitButton ) {
		if ( submitButton && submitButton.hasAttribute( 'disabled' ) ) {
			submitButton.removeAttribute( 'disabled' );
		}
	}

	//This solution used fix prices for every allowed currency
	watchCurrencySwitcher = ( form, orderArray ) => {
		if ( ! form ) {
			return;
		}

		const rounding = form.dataset.rounding;
		const baseCurrency = form.dataset.basecurrency;
		this.#toggleGiftAidVisibility( form, baseCurrency );

		const select = form.querySelector( 'select.switch_currency' );

		const ccFeeValue = form.querySelector( 'input.cc_fee' );

		select?.addEventListener( 'change', ( event ) => {
			this.#toggleGiftAidVisibility( form, event.target.value );
			const checkbox = form.querySelector( 'input[name="cc_fee"]' );
			if ( checkbox.checked ) {
				const ccFeeLabel = document.querySelector(
					'label[for="cc_fee_1"]'
				);
				if ( ccFeeLabel ) {
					this.triggerDoubleClick( ccFeeLabel );
				}
			}
			const allOptions = select?.querySelectorAll( 'option' );
			allOptions.forEach( ( option ) => {
				if ( option.hasAttribute( 'selected' ) ) {
					option.removeAttribute( 'selected' );
				}
			} );
			event.target.options[
				event.target.options.selectedIndex
			].setAttribute( 'selected', 'selected' );

			const selectedSymbol =
				event.target.options[ event.target.selectedIndex ].dataset
					.symbol;

			const allProductsCurrencySymbols = form.querySelectorAll(
				'.levcharity_form__products_item .currency_symbol'
			);
			allProductsCurrencySymbols?.forEach( ( span ) => {
				span.textContent = selectedSymbol;
			} );

			const allProducts = form.querySelectorAll(
				'.levcharity_form__products_item'
			);

			allProducts.forEach( ( product ) => {
				product.dataset.currencysymbol = selectedSymbol;
				const price = product.querySelector( '.product_price' );
				const newPrice = product.getAttribute(
					`data-price-${ event.target.value }`
				);
				if ( rounding ) {
					price.textContent = Math.ceil(
						Number( newPrice )
					).toLocaleString( 'en-US', {
						maximumFractionDigits: 2,
					} );
				} else {
					price.textContent = Number( newPrice ).toLocaleString(
						'en-US',
						{
							maximumFractionDigits: 2,
						}
					);
				}
			} );

			if ( orderArray.length > 0 ) {
				orderArray.forEach( ( product ) => {
					product.currency_symbol = selectedSymbol;
					let newPrice = 0;

					allProducts.forEach( ( item ) => {
						if ( item.dataset.id === product.id ) {
							newPrice = item.getAttribute(
								`data-price-${ event.target.value }`
							);
						}
					} );
					if ( checkbox?.checked ) {
						product.price =
							Number( newPrice ) +
							( Number( newPrice ) *
								Number( ccFeeValue.value ) ) /
								100;
					} else {
						product.price = Number( newPrice );
						product.priceWithoutFee = Number( newPrice );
					}
				} );

				this.#clearSummaryTable( form );
				this.#createSummaryRows( form, orderArray );
				this.#clearSummaryTotal( form );
				this.#createSummaryTotal( form, orderArray );
			}
		} );
	};

	handleStickyBarSubmit() {
		if ( this.#stickyBarSubmitButton ) {
			this.#stickyBarSubmitButton.addEventListener(
				'click',
				( event ) => {
					event.preventDefault();
					const formToSubmitButton = document.querySelector(
						'form.donation_form button[name="add-to-cart"]'
					);
					if ( formToSubmitButton ) {
						formToSubmitButton.click();
					}
				}
			);
		}
	}


	checkoutItemsCounter() {
		const checkout_equipment_item_remove_buttons = document.querySelectorAll('.levcharity-donation-checkout-fields-equipment-item-remove > svg');
		const checkout_equipment_item_change_quantity_buttons = document.querySelectorAll('.levcharity-donation-checkout-fields-equipment-item-quantity');
		let timeout = false;

		if(checkout_equipment_item_change_quantity_buttons){
			checkout_equipment_item_change_quantity_buttons.forEach((button) => {
				button.addEventListener('click', (event) => {

					if (button.classList.contains('disabled')){
						return;
					}

					let math_action = '';
					if(button.classList.contains('minus')){
						math_action = 'minus';
					}
					if(button.classList.contains('plus')){
						math_action = 'plus';
					}
					if(!math_action){
						return;
					}

					let parentElement = button.closest('.levcharity-donation-checkout-fields-equipment-item');
					let quantity = parentElement.querySelector('.quantity');
					let quantity_count = '';

					if (quantity) {
						let quantity_value = parseInt(quantity.textContent, 10);
						if (math_action == 'plus') {
							let max_quantity = Number(quantity.dataset.max ?? 0);
							if (max_quantity > 0) {
								// Don't allow incrementing beyond the maximum
								quantity_count = quantity_value + 1 <= max_quantity ? quantity_value + 1 : quantity_value;
							} else {
								quantity_count = quantity_value + 1;
							}
							quantity.textContent = quantity_count;
						} else if (math_action == 'minus') {
							quantity.textContent = quantity_value - 1;
							quantity_count = quantity_value - 1;
						}
					}

					// Update attendee fields based on seats
					const seats = parseInt(parentElement.getAttribute('data-seats'), 10) || 1;
					const productId = parentElement.getAttribute('data-product-id');
					const productName = parentElement.getAttribute('data-name');
					const autoFill = parentElement.getAttribute('data-autofill');
					const holidays = parentElement.getAttribute('data-holidays');
					const isSponsorship = parentElement.closest('.sponsorships-condition') !== null;
					const productType = isSponsorship ? 'sponsorships' : 'tickets';
					const customFieldsContainer = document.querySelector('.custom-field-checkout-container');

					if (customFieldsContainer && productId) {
						const totalNeeded = Math.max(0, parseInt(quantity_count, 10) || 0) * seats;
						const existingFields = customFieldsContainer.querySelectorAll(`.custom-field-checkout-wrapper[data-product-id="${productId}"]`);
						const currentCount = existingFields.length;

						if (math_action == 'plus') {
							for (let i = currentCount; i < totalNeeded; i++) {
								const newField = document.createElement('div');
								newField.classList.add('has-white-background-color', 'custom-field-checkout-wrapper');
								newField.setAttribute('data-product-id', productId);
								newField.setAttribute('data-index', i);
								newField.setAttribute('data-name', productName);

								let html = `
									<h3>${productName} #${i + 1}</h3>
									<div class="two_columns">
										<input type="text" name="attendees[${productId}][${i}][first_name]" placeholder="First name*">
										<input type="text" name="attendees[${productId}][${i}][last_name]" placeholder="Last name*">
									</div>
								`;

								if (autoFill === 'on') {
									html += `
										<div>
											<input type="email" name="attendees[${productId}][${i}][email]" placeholder="Email">
										</div>
									`;
								}

								html += `<input type="hidden" name="attendees[${productId}][${i}][product_type]" value="${productType}">`;

								if (holidays === 'on') {
									html += `<div class="holidays-container">
										<h3 class="holidays-title">Which holiday(s) is this person attending:</h3>
										<div class="two_columns custom-checkbox-wrapper">
											<div>
												<input id="rosh_hashanah[${productId}][${i}][holidays][]" type="checkbox" name="attendees[${productId}][${i}][holidays][]" value="Rosh hashanah">
												<label for="rosh_hashanah[${productId}][${i}][holidays][]" tabindex="0">Rosh Hashanah</label>
											</div>
											<div>
												<input id="yom_kipur[${productId}][${i + 1}][holidays][]" type="checkbox" name="attendees[${productId}][${i}][holidays][]" value="Yom Kipur">
												<label for="yom_kipur[${productId}][${i + 1}][holidays][]" tabindex="0">Yom Kippur</label>
											</div>
										</div>
									</div>`;
								}

								newField.innerHTML = html;

								if (existingFields.length > 0) {
									const lastField = existingFields[existingFields.length - 1];
									lastField.after(newField);
								} else {
									customFieldsContainer.appendChild(newField);
								}
							}
						} else if (math_action == 'minus') {
							for (let i = currentCount - 1; i >= totalNeeded; i--) {
								const fieldToRemove = existingFields[i];
								if (fieldToRemove) {
									fieldToRemove.remove();
								}
							}
						}
					}

					let item_key = parentElement.getAttribute('data-id');
					let formData = new FormData();
					formData.append('action', 'levcharity_donatation_checkout_change_equipment_item');
					formData.append('item_key', item_key);
					formData.append('math_action', math_action);
					formData.append('quantity', quantity_count);

					if(timeout){
						clearTimeout(timeout);
					}

					timeout = setTimeout(function (){
						fetch(admin_ajax, {
							method: 'POST',
							body: formData,
							credentials: 'same-origin',
						}).then(response => response.json())
							.then(data => {

								if (data.success && !data.redirect) {
									let updated_quantity = data.quantity;
									if (updated_quantity == 0) {
										parentElement.remove();
									}

									let quantity_container = parentElement.querySelector('.quantity');
									if (quantity_container) {
										quantity_container.innerText = updated_quantity;
									}

									let decrease_quantity_button = parentElement.querySelector('.levcharity-donation-checkout-fields-equipment-item-quantity.minus');
									if (decrease_quantity_button && updated_quantity <= 0) {
										parentElement.remove();
									}

									document.body.dispatchEvent(new Event('update_checkout'));
								}

								if (data.success && data.redirect) {
									window.location.href = data.redirect;
								}
							})
							.catch(error => {
								console.error('Error:', error);

								let quantity_value = parseInt(quantity.textContent, 10);
								if (math_action == 'plus') {
									quantity.textContent = quantity_value - 1;
								} else if (math_action == 'minus') {
									quantity.textContent = quantity_value + 1;
								}
							});
					}, 800);

				});
			});

		}

		let disabled = false;

		if (checkout_equipment_item_remove_buttons) {
			checkout_equipment_item_remove_buttons.forEach((button) => {
				button.addEventListener('click', (event) => {
					if (button.classList.contains('disabled') || disabled){
						return;
					}
					let item_container = event.target.closest('.levcharity-donation-checkout-fields-equipment-item');
					if (item_container) {

						item_container.closest('.levcharity-donation-checkout-fields-equipments').classList.add('doing-ajax');

						// Getting cart item key
						let item_key = item_container.getAttribute('data-id');

						let formData = new FormData();
						formData.append('action', 'levcharity_donatation_checkout_remove_equipment_item');
						formData.append('item_key', item_key);

						button.classList.add('disabled');
						disabled = true;
						item_container.style.display = 'none'
						fetch(admin_ajax, {
							method: 'POST',
							body: formData,
							credentials: 'same-origin',
						})
							.then(response => response.json())
							.then(data => {
								disabled = false;
								button.classList.remove('disabled');
								item_container.closest('.levcharity-donation-checkout-fields-equipments').classList.remove('doing-ajax');
								if (data.success && !data.redirect) {

									item_container.remove();
									//Triggering update_checkout to update woocommerce form
									document.body.dispatchEvent(new Event('update_checkout'));
								}
								if (data.success && data.redirect) {
									item_container.remove();
									window.location.href = data.redirect;
								}
							})
							.catch(error => {
								console.error('Error:', error);
								item_container.style.display = ''
								disabled = false;
								button.classList.remove('disabled');
								item_container.closest('.levcharity-donation-checkout-fields-equipments').classList.remove('doing-ajax');
							})
					}
				});
			});
		}
	}

	triggerDoubleClick( element ) {
		element.click();

		setTimeout( () => {
			element.click();
		}, 10 );
	}

	handleCustomFieldsVisibility() {
		const customFieldsWrapper = document.getElementById('lev-charity-custom-fields-wrapper');
		if (!customFieldsWrapper) {
			return;
		}

		const hideOnTabsAttr = customFieldsWrapper.getAttribute('data-hide-on-tabs');
		if (!hideOnTabsAttr) {
			customFieldsWrapper.style.display = '';
			return;
		}

		let hideOnTabs = [];
		try {
			hideOnTabs = JSON.parse(hideOnTabsAttr);
		} catch (e) {
			console.error('Failed to parse data-hide-on-tabs attribute:', e);
			return;
		}

		const activeTab = document.querySelector('.event-multi-ticket-form__tabs-item.active, .levcharity_tabs__item.active');
		if (activeTab) {
			let tabClass;
			if (activeTab.hasAttribute('data-tab')) {
				tabClass = activeTab.getAttribute('data-tab');
			} else {
				tabClass = Array.from(activeTab.classList).find(c => c.endsWith('_tab') && c !== 'advance_event_order_tab');
			}
			const activeTabSlug = tabClass ? tabClass.replace('_tab', '') : '';
			console.log(activeTabSlug);
			if (hideOnTabs.includes(activeTabSlug)) {
				customFieldsWrapper.style.display = 'none';
			} else {
				customFieldsWrapper.style.display = '';
			}
		}
	}

	/**
	 * admin-ajax.php has no URL language. Sync WPML cookies from html[lang], then send the same for PHP.
	 */
	appendWpmlLanguageToFormData( formData ) {
		const lang = this.getWpmlLanguageFromDocument();
		if ( ! lang ) {
			return;
		}
		formData.append( 'levcharity_wpml_lang', lang );
		const primary = this.getWpmlPrimaryFromBcp47( lang );
		if ( ! primary ) {
			return;
		}
		const path = ';path=/';
		const maxAge = ';max-age=' + String( 365 * 24 * 60 * 60 );
		const sameSite = ';SameSite=Lax';
		const secure =
			window.location.protocol === 'https:' ? ';Secure' : '';
		document.cookie =
			'wp-wpml_current_language=' +
			encodeURIComponent( primary ) +
			path +
			maxAge +
			sameSite +
			secure;
		document.cookie =
			'icl_current_language=' +
			encodeURIComponent( primary ) +
			path +
			maxAge +
			sameSite +
			secure;
	}

	getWpmlLanguageFromDocument() {
		if ( typeof document === 'undefined' ) {
			return '';
		}
		const raw = document.documentElement.getAttribute( 'lang' );
		return raw && raw.trim() ? raw.trim() : '';
	}

	/**
	 * WPML cookie values use the language code (e.g. en from en-US).
	 */
	getWpmlPrimaryFromBcp47( bcp47 ) {
		if ( ! bcp47 || typeof bcp47 !== 'string' ) {
			return '';
		}
		const primary = bcp47.trim().split( '-' )[ 0 ].toLowerCase();
		return primary.length >= 2 ? primary : '';
	}
}
